import { Expose } from 'class-transformer';

import { ExposeRawData } from '@lib/common/decorators';

export class SnCameraAiDetectionType {
  @Expose()
  public confidence: number;

  @Expose()
  public labels: any[];

  @Expose()
  public id: number;

  @Expose()
  public name: string;

  @Expose()
  public allowedLabels: any[];

  @Expose()
  public schedules: any[];

  @Expose()
  public roi: any[];

  @Expose()
  public meta: any;

  @Expose()
  public postDetection: any;

  @Expose()
  public detectionTimeout: number;

  @Expose()
  public type: string;

  @Expose()
  public timezone: string;

  @Expose()
  @ExposeRawData()
  public extraParams: any;
}
